// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconPaginationCarouselArrowLeft: React.FC<{ width?: number; height?: number }> = ({
    width = 56,
    height = 56,
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 40 40">
        <g fill="none">
            <circle cx="20" cy="20" r="19" fill="currentColor" fillRule="evenodd" stroke="#FFF" strokeWidth="2" />
            <path
                fill="currentColor"
                d="M12.281 20.71c-.375-.376-.375-1.044 0-1.42l7.004-7.008c.375-.376 1.042-.376 1.417 0 .375.375.375 1.043 0 1.418L15.408 19H27c.541 0 1 .459 1 1.001 0 .542-.459 1.001-1 1.001H15.408l5.294 5.299c.375.375.375 1.043 0 1.418-.417.376-1.042.376-1.417 0L12.28 20.71Z"
            />
        </g>
    </svg>
);

export default React.memo(IconPaginationCarouselArrowLeft);
